import { render, staticRenderFns } from "./IconFileFormat.vue?vue&type=template&id=0310d1f4&scoped=true&"
import script from "./IconFileFormat.vue?vue&type=script&lang=js&"
export * from "./IconFileFormat.vue?vue&type=script&lang=js&"
import style0 from "./IconFileFormat.vue?vue&type=style&index=0&id=0310d1f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310d1f4",
  null
  
)

export default component.exports